<template>
  <aside class="menu">
    <p class="menu-label">
      General
    </p>
    <ul class="menu-list">
      <li>
        <router-link :to="{ name: 'cars' }">
          Cars
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'settings' }">
          Settings
        </router-link>
      </li>
    </ul>

    <p class="menu-label">
      Cars
    </p>
    <ul class="menu-list">
      <li v-for="car in cars" v-bind:key="car.id">
        <router-link :to="{ name: 'statistics', params: { id: car.id } }">
          {{ car.make }} {{ car.model }}
        </router-link>
        <ul>
          <li>
            <router-link :to="{ name: 'gas', params: { id: car.id } }">
              Gas
            </router-link>
            <router-link :to="{ name: 'expenses', params: { id: car.id } }">
              Expenses
            </router-link>
            <router-link :to="{ name: 'statistics', params: { id: car.id } }">
              Overview
            </router-link>
          </li>
        </ul>
      </li>
    </ul>
  </aside>
</template>

<script>
import CARS from '@/graphql/cars/cars.gql';

export default {
  name: 'SideMenu',
  data() {
    return {
      cars: null,
    };
  },
  apollo: {
    cars: CARS,
  },
};
</script>

<style lang="scss" scoped>
  @import "~bulma/sass/utilities/all";
  .menu {
    .menu-list {
      .router-link-active {
        color: $primary;
      }
    }
  }
</style>
